import { z } from 'zod';
import { idSchema, isoDateSchema, memberSummarySchema } from './common';
/**
 * Ce que le cercle accroche à une fiche de rhum : des liens et une discussion.
 *
 * Les deux sont ouverts à tous les membres, à tout moment, et ne relèvent pas d'une séance —
 * on retombe sur un article six mois après la dégustation. La modération se limite au
 * retrait (`canRemoveRumContribution`) : rien ne se corrige après coup, un fil de discussion
 * s'assume tel qu'il s'est écrit.
 */
// ------------------------------------------------------------------------- liens utiles
/**
 * Le lien est restreint à http(s), et cela n'est pas cosmétique.
 *
 * L'URL est rendue dans un `href`. Un `javascript:` collé dans le champ y devient du code
 * exécutable au clic — l'injection la plus facile qui soit sur une application où tout le
 * monde écrit. Un `data:` ou un `file:` n'auraient de toute façon aucun sens pour les autres
 * membres, qui ne partagent ni la page ni le disque de celui qui a collé.
 *
 * Le contrôle est celui de `z.url()`, et non un `new URL()` dans un `refine` : ce paquet est
 * compilé sans les types du DOM ni ceux de Node — c'est ce qui lui permet d'être importé
 * aussi bien par Nest que par le navigateur — et `URL` n'y est donc pas déclaré. Le confier à
 * zod garantit en prime que le refus est le même des deux côtés, mot pour mot.
 */
export const createRumLinkSchema = z.object({
    url: z
        .url({ protocol: /^https?$/, error: 'Un lien doit commencer par http:// ou https://.' })
        .trim()
        .max(2048),
    /** Vide : le front retombe sur le nom de domaine. */
    label: z.string().trim().max(120).nullish(),
});
export const rumLinkViewSchema = z.object({
    id: idSchema,
    url: z.string(),
    label: z.string().nullable(),
    /** Null si le membre a été anonymisé depuis. */
    addedBy: memberSummarySchema.nullable(),
    createdAt: isoDateSchema,
});
// ------------------------------------------------------------------------- commentaires
export const createRumCommentSchema = z.object({
    body: z
        .string()
        .trim()
        .min(1, 'Un commentaire vide ne se poste pas.')
        // Deux mille signes : de quoi raconter une bouteille sans transformer le fil en article.
        .max(2000, 'Un commentaire ne peut pas dépasser 2000 caractères.'),
});
export const rumCommentViewSchema = z.object({
    id: idSchema,
    body: z.string(),
    author: memberSummarySchema.nullable(),
    createdAt: isoDateSchema,
});
//# sourceMappingURL=rum-contributions.js.map